/**
 * ⭐ THE ONLY WORDS A PASSWORD-RESET REQUEST OR SET-NEW-PASSWORD CALL MAY SEND
 * BACK (MC17430 corrections). They are fixed: a library message, a database
 * message or any other raw error text never reaches the response. The server
 * handler sends these; the reset page shows them.
 */
export const RESET_REQUEST_NEUTRAL_MESSAGE =
  "If an account with that email exists, we've sent a password reset link";

export const RESET_LINK_INVALID_MESSAGE =
  "This reset link is invalid or has expired.";
export const RESET_PASSWORD_REJECTED_MESSAGE =
  "That password can't be used. Please choose a different one.";
export const RESET_FAILED_MESSAGE =
  "We could not reset your password. Please try again.";

export const RESET_FAILURE_MESSAGES: readonly string[] = [
  RESET_LINK_INVALID_MESSAGE,
  RESET_PASSWORD_REJECTED_MESSAGE,
  RESET_FAILED_MESSAGE,
];
